export const SKIP_LINK_IDS = {
  MAIN_CONTENT: 'main-content',
  ACCESSORIES: 'accessories'
} as const;
